










































import { Component, Watch, Prop, Vue } from 'vue-property-decorator';
import SettingsPanel from '../powerbar/components/SettingsPanel/SettingsPanel.vue';
import HelpPanel from '../powerbar/components/HelpPanel/HelpPanel.vue';
import { SidebarState } from '../powerbar/store';
import { namespace } from 'vuex-class';
import { ClassLogo } from "../powerbar/assets/icons";
import vueInstance from '@/axiom-vue-demo';
import { isAbsolute } from 'path';
const sidebarState = namespace('SidebarState');

@Component({
  name: 'AxScopelessbar',
  components: {
    SettingsPanel,
    HelpPanel,
    ClassLogo,
  },
})
export default class AxScopelessbar extends Vue {
  @Prop({ default: 'email@class.com.au' }) public username: string;
  @Prop({ required: false }) public enableHelpPanel: any;

  @sidebarState.Getter isSidebarOpen: boolean;
  @sidebarState.Action closeSidebar: () => void;
  @sidebarState.Action toggleSidebar: () => void;
  @sidebarState.Getter isSettingsPanelOpen: boolean;
  @sidebarState.Action closeSettings: () => void;
  @sidebarState.Action toggleSettings: () => void;
  @sidebarState.Getter isWhatsNewPanelOpen: boolean;
  @sidebarState.Action closeWhatsNew: () => void;
  @sidebarState.Action toggleWhatsNew: () => void;
  @sidebarState.Getter isHelpPanelOpen: boolean;
  @sidebarState.Action closeHelp: () => void;
  @sidebarState.Action toggleHelp: () => void;
  @sidebarState.Mutation setEnableHelpPanel: (enable: any) => void;

  @Watch('enableHelpPanel')
  onEnableHelpPanelChange(val: any) {
    this.setEnableHelpPanel(true);; // Ensure help panel is enabled when prop changes
  }

  public mounted() {
    this.setEnableHelpPanel(true); // Ensure help panel is enabled on mount
  }

  public tryCloseSidebar(e: Event): void {
    const settingsButton = this.$refs.settingsButton as HTMLElement;
    const helpPanelButton = this.$refs.helpPanelButton as HTMLElement;
    const eventTarget = e.target as HTMLElement;

    if (this.isSettingsPanelOpen &&
      settingsButton !== eventTarget &&
      settingsButton?.contains(eventTarget) === false) {
      this.closeSettings();
    }

    if (this.isHelpPanelOpen &&
      helpPanelButton !== eventTarget &&
      helpPanelButton?.contains(eventTarget) === false) {
      this.closeHelp();
    }
  }

  // Lifecycle hooks
  public beforeCreate() {
    SidebarState.register?.(this.$store);
  }

  public destroyed() {
    SidebarState.unregister?.(this.$store);
  }
}
